module.exports = __webpack_public_path__ + "static/media/service-scenario-bg1.8b8265a4.png";